import { useMemo } from 'react';
import { Configuration, LegacyIDPApi } from '@vis-auth/vis-user-client';

const USER_SERVICE_BASE_PATH = '/api/users';

const useConfiguration = (basePath: string): Configuration => {
  const configuration = useMemo(
    () =>
      new Configuration({
        basePath: `${window.location.origin}${basePath}`,
      }),
    [basePath],
  );
  return configuration;
};

const useLegacyIdpApi = (): LegacyIDPApi => {
  const config = useConfiguration(USER_SERVICE_BASE_PATH);
  const api = useMemo(() => new LegacyIDPApi(config), [config]);
  return api;
};

export default useLegacyIdpApi;
